import { useSortable } from "@dnd-kit/sortable";
import {
  Box,
  Button,
  Checkbox,
  NumberFormatter,
  NumberInput,
  Select,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { tblComboSetGroupModels } from "../../model/Comboset";
import { IconGripVertical } from "@tabler/icons-react";
interface GroupItem {
  id?: number | null;
  groupName: string;
  sortOrder?: number;
  setId?: number | null;
  tblComboSetProdCommands?: any[];
}

type Props = {
  itemIndex: number;
  indexGroup: number;
  indexItem: number;
  dataGroupItem: tblComboSetGroupModels[];
  setDataGroupItem: React.Dispatch<
    React.SetStateAction<tblComboSetGroupModels[]>
  >;
};
const ItemProduct = ({
  itemIndex,
  indexItem,
  indexGroup,
  dataGroupItem,
  setDataGroupItem,
}: Props) => {
  // Đảm bảo id truyền vào useSortable khớp với SortableContext
  const productId = String(
    dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[indexItem]?.itemId ??
      `product-${indexItem}`
  );
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: productId,
    });

  const handleChangeDataComboSetProd = (
    value: any,
    key: any,
    indexGroup: number,
    indexItem: number
  ) => {
    setDataGroupItem((prevData) => {
      return prevData.map((itemGroup: GroupItem, idxGroup: number) => {
        if (idxGroup === indexGroup) {
          const updatedCommands = itemGroup?.tblComboSetProdCommands?.map(
            (item: any, idxItem: number) => {
              return idxItem === indexItem ? { ...item, [key]: value } : item;
            }
          );

          return { ...itemGroup, tblComboSetProdCommands: updatedCommands };
        } else {
          return itemGroup;
        }
      });
    });
  };

  const handleUpdateItemSortOrder = (
    indexItem: number,
    indexGroup: number,
    newSortOrder: number | string
  ) => {
    const numSortOrder =
      typeof newSortOrder === "string"
        ? parseInt(newSortOrder, 10)
        : newSortOrder;

    // Validate the sort order
    const maxSortOrder =
      dataGroupItem[indexGroup]?.tblComboSetProdCommands?.length || 0;
    if (
      isNaN(numSortOrder) ||
      numSortOrder < 1 ||
      numSortOrder > maxSortOrder
    ) {
      return; // Ignore invalid input
    }

    setDataGroupItem((prevData: tblComboSetGroupModels[]) => {
      const newData = [...prevData];
      const products = [
        ...(newData[indexGroup]?.tblComboSetProdCommands || []),
      ];
      const currentProduct = { ...products[indexItem] };
      const currentSortOrder = currentProduct.sortOrder || indexItem + 1;
      const targetIndex = numSortOrder - 1;
      const conflictingItemIndex = products.findIndex(
        (item, idx) =>
          (item.sortOrder === numSortOrder || idx === targetIndex) &&
          idx !== indexItem
      );

      if (conflictingItemIndex !== -1) {
        products.forEach((item, idx) => {
          if (idx === indexItem) {
            item.sortOrder = numSortOrder;
          } else if (idx === conflictingItemIndex) {
            item.sortOrder = currentSortOrder;
          }
        });
      } else {
        products[indexItem].sortOrder = numSortOrder;
      }
      newData[indexGroup] = {
        ...newData[indexGroup],
        tblComboSetProdCommands: products,
      };

      return newData;
    });
  };

  const handleRemoveItem = (indexItem: number, indexGroup: number) => {
    const newData = [...dataGroupItem];
    dataGroupItem[indexGroup]?.tblComboSetProdCommands?.splice(indexItem, 1);
    setDataGroupItem(newData);
  };

  return (
    <Box
      mt={12}
      ref={setNodeRef}
      {...attributes}
      style={{
        display: "grid",
        width: "100%",
        gridTemplateColumns: "5% 20% 10% 15% repeat(3, 10%) 12%",
        alignItems: "center",
        gap: "16px",
        // padding: "10px",
        borderBottom: "1px solid #eee",
      }}
    >
      <Box style={{ justifyContent: "center", display: "flex" }}>
        {Number(indexItem + 1)}
      </Box>

      <TextInput
        type="text"
        placeholder="Tên sản phẩm"
        value={
          dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[
            indexItem
          ]?.itemName?.toString() || ""
        }
      />

      <Box>
        <Text>
          Giá đang bán:{" "}
          <NumberFormatter
            style={{ color: "red" }}
            value={
              dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[indexItem]
                ?.itemPrice || 0
            }
            thousandSeparator
            suffix=" đ"
          />
        </Text>
      </Box>

      <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Text size="sm">Cài giảm</Text>
        <NumberInput
          size="sm"
          w={80}
          value={Number(
            dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[indexItem]
              ?.discoutValue
          )}
          onChange={(e) =>
            handleChangeDataComboSetProd(
              e,
              "discoutValue",
              indexGroup,
              indexItem
            )
          }
        />
        <Select
          size="sm"
          w={100}
          value={
            dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[indexItem]
              ?.discoutType !== undefined &&
            dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[indexItem]
              ?.discoutType !== null
              ? String(
                  dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[
                    indexItem
                  ]?.discoutType
                )
              : null
          }
          onChange={(e) =>
            handleChangeDataComboSetProd(
              e,
              "discoutType",
              indexGroup,
              indexItem
            )
          }
          placeholder={"Đơn vị"}
          data={[
            { value: "0", label: "%" },
            { value: "1", label: "VNĐ" },
          ]}
        />
      </Box>
      <Checkbox
        label="Hiển thị đầu tiên"
        checked={
          dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[indexItem]
            ?.isFirstRow === "Y"
            ? true
            : false
        }
        onChange={(e) =>
          handleChangeDataComboSetProd(
            e.target.checked ? "Y" : "N",
            "isFirstRow",
            indexGroup,
            indexItem
          )
        }
      />

      <Checkbox
        label="Là miễn phí"
        checked={
          dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[indexItem]
            ?.isFree === "Y"
            ? true
            : false
        }
        onChange={(e) =>
          handleChangeDataComboSetProd(
            e.target.checked ? "Y" : "N",
            "isFree",
            indexGroup,
            indexItem
          )
        }
      />

      <Checkbox
        label="Khuyên mua"
        checked={
          dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[indexItem]
            ?.isHot === "Y"
            ? true
            : false
        }
        onChange={(e) =>
          handleChangeDataComboSetProd(
            e.target.checked ? "Y" : "N",
            "isHot",
            indexGroup,
            indexItem
          )
        }
      />

      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {/* <Tooltip label="Thứ tự hiển thị">
          <NumberInput
            size="sm"
            w={60}
            placeholder="STT"
            min={1}
            max={
              dataGroupItem[indexGroup]?.tblComboSetProdCommands?.length || 1
            }
            value={
              dataGroupItem[indexGroup]?.tblComboSetProdCommands?.[indexItem]
                ?.sortOrder || indexItem + 1
            }
            onChange={(value) =>
              handleUpdateItemSortOrder(indexItem, indexGroup, value)
            }
            style={{ height: 36 }}
          />
        </Tooltip> */}

        <Tooltip label="Xóa sản phẩm">
          <Button
            variant="subtle"
            type="button"
            color="red"
            style={{ minWidth: 16, height: 36 }}
            onClick={() => handleRemoveItem(indexItem, indexGroup)}
          >
            <IconTrash size={20} />
          </Button>
        </Tooltip>
        {/* Icon kéo thả, chỉ truyền listeners vào đây */}
        <span {...listeners} style={{ cursor: "grab", marginRight: 8 }}>
          <IconGripVertical size={18} />
        </span>
      </Box>
    </Box>
  );
};

export default ItemProduct;
